const state = {
  selectedLand: null,
  cityName: '',
  cityLevel: 1,
  arenaCount: 0
}

const mutations = {
  SET_SELECTED_LAND(state, land) {
    state.selectedLand = land
  },
  SET_CITY_INFO(state, cityInfo) {
    state.cityName = cityInfo.name
    state.cityLevel = cityInfo.level || 1
    state.arenaCount = cityInfo.lands?.length || 0
  }
}

const actions = {
  selectLand({ commit }, land) {
    commit('SET_SELECTED_LAND', land)
  },
  setCityInfo({ commit }, cityInfo) {
    commit('SET_CITY_INFO', cityInfo)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
